import React,{useState,useEffect} from 'react'
import { useLocation } from "react-router-dom";
import { calculateOtherDepreciation } from '../services/asset.service';
import  * as CryptoJS  from "crypto-js";
function MultiListPopUp2(props) {
    
    var block = props.show2? "display-block": "";
    const [validName, setValidName] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [popupLoading, setPopupLoading] = useState(false);
    const [mon, setMon] = useState(false);
    const [fy, setFY] = useState(false);
    const [listOptions1, setListData1] = useState([]);
    //const [listOptions2, setListData2] = useState([]);
    
    var asset_data = [...props.data2];
    //console.log('asset_data='); console.log(asset_data);
    const [foundAssets, setFoundAssets] = useState(asset_data);

    
    const filter = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
        const results = asset_data.filter((asset) => {
            return asset.tag.startsWith(keyword);
        });
        setFoundAssets(results);
        } else {
        setFoundAssets(asset_data);
        // If the text field is empty, show all users
        }
        setName(keyword);
    };

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Mon = query.get('m');
    const FY = query.get('fy'); 
    //const elementRef = useRef();
    useEffect(() => {
          if(Mon!='' && Mon!=null){
            setMon(Mon);
          }
          if(FY!='' && FY!=null){
              setFY(FY);
            }
        //setListData2({listOptions1});
        //setFoundAssets(asset_data);
        setListData1(listOptions1);
    }, []);
    // check array pushListOptions
    //refrest_ListData1
    const refrest_ListData1 = (e) => {
        setListData1(listOptions1);
    }
    const pushListOptions=(obj)=>{
        var flag=0;
        setPopupLoading('..');
        listOptions1.forEach((elem)=>{
          if(obj.value===elem.value && obj.label===elem.label){
            flag=1;
        }
      });
      setPopupLoading(false);
      if(flag===1){
          return false;
      }else{
          return true;
      }
    };

   //search filter 
   // the value of the search field 
  const [name, setName] = useState('');
   // the search result
  //const [foundAssets, setFoundAssets] = useState(asset_data);
  //console.log('foundAssets='); console.log(foundAssets);
  
  //start validation   
  const handleSubmit = async (e) => { 
      e.preventDefault(); var valid_Name=true;
  if(fy ===''){
        setValidName(false);
        alert("Financial year is missing"); valid_Name=false;
  }
  if(mon ===''){ 
        setValidName(false);
        alert('Month is missing'); valid_Name=false;
  }
  if(listOptions1.length===0){ //alert(listOptions1.length);
        setValidName(false);
        alert('Please select atleast one Asset'); valid_Name=false;
  }
  if (!valid_Name) { //alert(valid_Name); 
          return false;
      }else{ //alert(mon); alert(fy);
          saveData();
      }
  }

  const saveData = async () => {

    var obj = {
      //'tag': tag, 
      'session':fy, 
      'month':mon,
      'assets':listOptions1,
      'company_id':sessionStorage.getItem('LoggedInCompanyId'),
      'division_id':sessionStorage.getItem('LoggedInDivisionId'),
    };
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data':obj,
        'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
    let oData = {'token':EncryptData}
    try {  //setLoading('..'); // Set loading before sending API request
        calculateOtherDepreciation(oData).then(function(res){
            //console.log(res);
            setSuccess(res.data.message); //alert('a');
            //elementRef.current.focus();
        }); setValidName(false);
        props.setLoading(false); // Stop loading
    } catch (err) { 
        setSuccess(false);
        //console.error(err);
        if (!err?.data1) {
            setErrMsg('No Server Response');
        } else if (err.data1?.status === 409) {
            setErrMsg('Record already exists');
        } else {
            setErrMsg('Insert/Update Failed');
        }
        props.setLoading(false); // Stop loading
    }
  }

    const handleMoveList1 = (e) => {
        const selectedOptions =[];
        //alert('dd');
        var options1 = document.getElementById('lstBox3').options;
        //console.log(options1);
        for (var i = 0, l = options1.length; i < l; i++) {
            if (options1[i].selected) {
                var option1 = {
                    label: options1[i].label,
                    value: options1[i].value,
                }
                if (pushListOptions(option1)) {
                    listOptions1.push(option1);
                }
            }
        } //setListData2(listOptions1); 
        setListData1((prevList) => prevList.filter((option) => !selectedOptions.find((selected) => selected.value === option.value)));
        
        //console.log('listOptions1');console.log(listOptions1);
    }
    const handleMoveList2 = (e) => {
        const selectedOptions2 =[];
        var options2 = document.getElementById('lstBox4').options;
        //console.log(options1);
        for (var i = 0, l = options2.length; i < l; i++) {
            if (options2[i].selected) {
                var option1 = {
                    label: options2[i].label,
                    value: options2[i].value,
                }
                if (pushListOptions(option1)) {
                    listOptions1.push(option1);
                }
            }
        } //setListData2(listOptions1); 
        setListData1((prevList) => prevList.filter((option) => !selectedOptions2.find((selected) => selected.value === option.value)));
        
        //console.log('listOptions1');console.log(listOptions1);
    }
    const handleAllMoveList1 = (e) => { //alert('dd');
        //var listOptions = [];
        var options1 = document.getElementById('lstBox3').options;
        for (var i = 0, l = options1.length; i < l; i++) {
            var option1 = {
                label: options1[i].label,
                value: options1[i].value,
            }
            if (pushListOptions(option1)) {
                listOptions1.push(option1);
            }
            //listOptions1.push(option1);
        } //setListData2(listOptions1); console.log(listOptions2);
        setListData1(listOptions1);
    }
    const handleAllRemove = (e) => { //alert('dd');
        //var options2 = document.getElementById('lstBox3').options;
        //alert(options.length);
        setListData1([]); 
    }
    
    return (
        <div className={block +" custom-modal width-80 height-80"}>
        {success ? (
				<div className="alert alert-success" role="alert"><i className="bi bi-check-circle-fill"></i>{success}</div>
			        ) : ( errMsg ? (<div className="alert alert-danger" role="alert"><i className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>):('')
                ) }
        
        <div className="custom-close" > <span onClick={ ()=>{props.showsetter2(false)} } className="bi bi-x-circle-fill"></span> </div>
            <div className="title custom-modal-title">
                <h5>{props.title2}</h5> 
                
            </div>
            
            <div className="subject-info-box-1">
            <input  type="search"  value={name} onChange={filter} className="form-control" placeholder="Filter"
            />
            <select multiple="multiple" id='lstBox3' className="form-select form-select-sm">
            {foundAssets && foundAssets.length > 0 ? (
                foundAssets.map((option) => (
                <option value={option.tag}>{option.tag}</option>
                ))
            ) : (
            <h1>No results</h1>
            )}
            </select>
        </div>

        <div className="subject-info-arrows text-center">{popupLoading ? (<div className="spinner-border text-primary" role="status">
                              <span className="sr-only">{popupLoading}</span>
                            </div>) : ('') }
        <button onClick={filter} value=""  className="btn btn-info btn-sm refresh">Refresh</button><br /><br />
        <input type='button' id='btnAllRight' onClick={handleAllMoveList1} value='Add All' className="btn btn-default" /><br />
        <input type='button' id='btnRight' onClick={handleMoveList1} value='>' className="btn btn-default" /><br />
        
        <input type='button' id='btnAllLeft' onClick={handleAllRemove} value='Remove All' className="btn btn-default" />
        </div>
    
        <div className="subject-info-box-2">
        {/*<div className="subject-refresh">
        <button onClick={refrest_ListData1} value=""  className="form-control btn-info refresh">Refresh</button>
            </div>*/}
        <select multiple="multiple" id='lstBox4' className="form-select form-select-sm">
            {   listOptions1.map((option) => (
                <option value={option.value}>{option.label}</option>
                )) }
        </select>
        </div>

        <div className="clearfix"></div>
        <form name="" onSubmit={handleSubmit}>
            <button onClick={ () =>{ //data.push();
                                    props.datasetter2(asset_data);
                                    }
                            } 
            className="btn btn-primary btn-md float-end"> Genrate </button>
            
        </form>
        
    </div>
    )
}

export default MultiListPopUp2